import { performRequestFourth } from 'common/apiHandler';
import apiEndPoints from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

/**
 * @param {string} firmUserId
 * @returns {string}
 */
const identityParams = (firmUserId) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return `tenant_id=${tenantId}&tenant_sk=${tenantSk}&firm_user_id=${firmUserId}`;
};

/**
 * @param {object} entry
 * @returns {object}
 */
const normalizeLogEntry = (entry = {}) => ({
  action: entry.action ?? entry.Action ?? 'promoted',
  timestamp: entry.timestamp ?? entry.Timestamp ?? null,
  user: entry.user ?? entry.User ?? entry.user_name ?? '',
  triggerSource: entry.triggerSource ?? entry.trigger_source ?? null,
  reason: entry.reason ?? entry.Reason ?? null,
});

/**
 * @param {object} response
 * @returns {{ promotionStatus: string, promotedAt: string|null, promotionSource: string|null, promotedBy: string|null, promotionLog: object[] }}
 */
export const normalizeDocumentPromotionStatus = (response) => {
  const payload = response?.data?.data || response?.data || response || {};

  const promotionLog = (payload.promotion_log || payload.promotionLog || []).map(normalizeLogEntry);

  return {
    promotionStatus: payload.promotion_status ?? payload.promotionStatus ?? 'not_promoted',
    promotedAt: payload.promoted_at ?? payload.promotedAt ?? null,
    promotionSource: payload.promotion_source ?? payload.promotionSource ?? null,
    promotedBy: payload.promoted_by ?? payload.promotedBy ?? null,
    promotionLog,
  };
};

/**
 * @param {{ fileId: string, firmUserId: string }} params
 */
export const getDocumentPromotionStatus = async ({ fileId, firmUserId }) => {
  const response = await performRequestFourth(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.medicalRecordPromotionStatus(fileId)}?${identityParams(firmUserId)}`
  );

  return normalizeDocumentPromotionStatus(response);
};

/**
 * @param {{ fileId: string, firmUserId: string, triggerSource: 'upload_checkbox'|'manual_mark' }} params
 */
export const promoteDocument = ({ fileId, firmUserId, triggerSource }) => {
  return performRequestFourth(apiEndPoints.methodType.POST, `${apiEndPoints.medicalRecordPromote(fileId)}?${identityParams(firmUserId)}`, {
    trigger_source: triggerSource,
  });
};

/**
 * @param {{ fileId: string, firmUserId: string }} params
 */
export const demoteDocument = ({ fileId, firmUserId }) => {
  return performRequestFourth(apiEndPoints.methodType.POST, `${apiEndPoints.medicalRecordDemote(fileId)}?${identityParams(firmUserId)}`);
};
